export enum DisplayNotificationType {
    SUCCESS = 'success',
    ERROR = 'error',
    WARNING = 'warning',
    INFO = 'info',
}

export interface DisplayNotification {
    id?: string;
    type: DisplayNotificationType;
    header?: string;
    message: string;
    durationMs?: number;
    onAction?: () => void;
    actionText?: string;
}


